import { Select, SelectProps } from 'antd';
import { Children, cloneElement, ReactElement } from 'react';
import { ALL_ITEMS_PAGE_SIZE } from 'core/http/pagination';

// antd's pagination can't relabel a page size, so this replaces its size selector and
// shows the all-items size as "All" instead of "999 / page".
const PageSizeSelect = ({ children, ...props }: SelectProps) => {
    const options = Children.map(children, (option) => {
        const element = option as ReactElement;
        const isAllItems = Number(element.props.value) === ALL_ITEMS_PAGE_SIZE;
        return isAllItems ? cloneElement(element, {}, 'All') : element;
    });

    return (
        <Select size="middle" {...props}>
            {options}
        </Select>
    );
};

PageSizeSelect.Option = Select.Option;

export default PageSizeSelect;
